import { Flex, Skeleton, Text } from "@radix-ui/themes";
import {
  ValidationRow,
  ProgressFormatter,
  TimeFrameFormatter,
} from "@/v2/features/validation/validation.utils";
import { AvgQaScoreFormatter } from "@/v2/components/formatters/AvgQaScoreFormatter";

interface ValidationMetricsProps {
  validation?: ValidationRow;
}

export function ValidationMetrics({ validation }: ValidationMetricsProps) {
  return (
    <Flex gap="6">
      <Flex direction="column" gap="1" minWidth="160px">
        <Text size="1" color="gray">
          Time Frame
        </Text>

        <Text size="2" color="gray" weight="medium" highContrast>
          {validation != null ? (
            <TimeFrameFormatter {...validation} />
          ) : (
            <Skeleton className="w-[160px] h-[26px] rounded-md" />
          )}
        </Text>
      </Flex>

      <Flex direction="column" gap="1" minWidth="160px">
        <Text size="1" color="gray">
          Progress
        </Text>

        {validation == null ? (
          <Skeleton className="w-[160px] h-[26px] rounded-md" />
        ) : (
          <>
            {validation.validated === "loading" ? (
              <Skeleton className="w-[160px] h-[26px] rounded-md" />
            ) : (
              <Text size="2" color="gray" weight="medium" highContrast>
                <ProgressFormatter {...validation} />
              </Text>
            )}
          </>
        )}
      </Flex>

      <Flex direction="column" gap="1" minWidth="160px">
        <Text size="1" color="gray">
          Avg. Score
        </Text>

        {validation == null ? (
          <Skeleton className="w-[160px] h-[26px] rounded-md" />
        ) : (
          <>
            {validation.avgQaScore == null ? (
              <Text size="2" color="gray" weight="medium" highContrast>
                -
              </Text>
            ) : (
              <>
                {validation.avgQaScore === "loading" ? (
                  <Skeleton className="w-[160px] h-[26px] rounded-md" />
                ) : (
                  <AvgQaScoreFormatter value={validation.avgQaScore} />
                )}
              </>
            )}
          </>
        )}
      </Flex>

      <Flex direction="column" gap="1" minWidth="160px">
        <Text size="1" color="gray">
          Auto Score
        </Text>

        {validation == null ? (
          <Skeleton className="w-[160px] h-[26px] rounded-md" />
        ) : (
          <>
            {validation.avgAutoQaScore == null ? (
              <Text size="2" color="gray" weight="medium" highContrast>
                -
              </Text>
            ) : (
              <>
                {validation.avgAutoQaScore === "loading" ? (
                  <Skeleton className="w-[160px] h-[26px] rounded-md" />
                ) : (
                  <AvgQaScoreFormatter value={validation.avgAutoQaScore} />
                )}
              </>
            )}
          </>
        )}
      </Flex>
    </Flex>
  );
}
